import axios from "../axiosConfig";

import {
  reducerIntegrationErrorsStatus,
  reducerGetIntegrationErrors,
} from "../../reducer/easymerch/reducers/reducerIntegrationErrors";
import { AppDispatch } from "../../reducer/store";
import { getToken } from "../axiosToken";

interface IFiltersIntegrationErrors {
  address: string;
  contracts: { id: number }[];
  date: string;
  description: string;
  merchs: { id: number }[];
  personId: string;
  projects: { id: number }[];
  singleTrip: boolean;
  sv: { id: number }[];
  types: string[];
  userId: string;
  visitNo: string;
  vsv: { id: number }[];
};

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const actionGetIntegrationErrors =
  (limit: number, offset: number) =>
    async (dispatch: AppDispatch, getState: () => any) => {
      const { token } = await getToken();
      axios.defaults.headers.common["Authorization"] = token;
      const store = getState();
      const filter =
        store.easymerch.integrationErrors.integrationErrorsInputValues;
      try {
        const response = await axios.post(`${BASE_URL}/json/em/incidents/list`, {
          limit,
          offset,
          contractType: 0,
          ...filter,
        });
        dispatch(
          reducerGetIntegrationErrors({ data: response.data, limit, offset })
        );
      } catch {
        console.log('err');
      }
    };

export const actionSetIntegrationErrors =
  (filter: IFiltersIntegrationErrors, limit: number, offset: number, isSingleTripValue: string) =>
    async (dispatch: AppDispatch) => {
      const { token } = await getToken();
      axios.defaults.headers.common["Authorization"] = token;
      try {
        const response = await axios.post(`${BASE_URL}/json/em/incidents/list`, {
            limit,
            offset,
            contractType: 0,
            ...filter,
          });
    
          const filteredData = {
            incidentFilter: response?.data?.incidentFilter,
            incidents: {
              ...response?.data?.incidents,
              data: response?.data?.incidents?.data && response?.data?.incidents?.data.filter((obj: any) => {
                if (isSingleTripValue === "Да") {
                  return obj.isSingleTrip === true;
                } else if (isSingleTripValue === "Нет") {
                  return obj.isSingleTrip === false;
                } else return response?.data?.incidents?.data;
              }),
            },
          };
          dispatch(
            reducerGetIntegrationErrors({ data: filteredData, limit, offset })
          );
      } catch {
        console.log('err');
      }
    };

export const actionUnloadIntegrationErrors =
  (contract: number) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    try {
      const response = await axios.get(
        `${BASE_URL}/json/em/incidents/export/${contract}`
      );
      dispatch(reducerIntegrationErrorsStatus(response.status));
    } catch (err) {
      dispatch(reducerIntegrationErrorsStatus(0));
    }
  };

export const actionImportReport =
  (files?: File[]) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    const headers = {
      Authorization: token,
      "Content-Type": "multipart/form-data",
    };

    const formData = new FormData();

    files && files.forEach((file: File) => {
      formData.append("excelFile", file, file.name);
    });

    try {
      const response = await axios.put(
        `${BASE_URL}/json/reports/import/em`,
        formData,
        {
          headers: headers,
        }
      );
      dispatch(reducerIntegrationErrorsStatus(response.status));
    } catch (err) {
      dispatch(reducerIntegrationErrorsStatus(1));
    }
  };